module.exports = __webpack_public_path__ + "Flag-702.3395f36059d2e94930fc2da368acaa34.svg";